<template>
  <el-dialog :visible.sync="visible" title="月卡过期未续费" :append-to-body="true" width="500px" :before-close="close">
    <el-form ref="form" :model="param" :rules="rules" label-width="100px" style="padding-right: 50px;">
      <el-form-item label="月卡名称" style="margin-top:20px;">
        {{ this.ruleInfo.ruleName }}
      </el-form-item>
      <el-form-item label="车牌号码" style="margin-top:20px;">
        {{ this.ruleInfo.plate }}
      </el-form-item>
      <el-form-item label="手机号码" style="margin-top:20px;">
        {{ this.ruleInfo.mobile }}
      </el-form-item>
      <el-form-item label="未续费原因" prop="remark">
        <el-input v-model="param.remark" type="textarea" placeholder="请输入未续费原因" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" :loading="isLoading" @click="confirm()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { reviewMonthCardRenewal } from '@/api/data'
export default {
  name: 'AddAmount',
  data() {
    return {
      visible: false,
      isLoading: false,
      param: {
        'remark':'',
        'id':''
      },
      ruleInfo:{},
      rules: {
        remark: [
          { required: true, message: '请输入未续费原因', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    initData(data) {
      this.rest();
      this.ruleInfo = JSON.parse(data.extend);
      this.param.id = data.id;
      this.visible = true
    },
    rest() {
      this.param = {
        'remark':'',
        'id':''
      }
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = JSON.parse(JSON.stringify(this.param))
          this.isLoading = true
          reviewMonthCardRenewal(data).then(res => {
            this.isLoading = false
            if (res.code === 200) {
              this.$message.success('提交成功')
              this.close()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    close() {
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
